import { ReactNode } from "react";
import loadingImg from "images/loading.svg";

interface Props {
  show?: boolean;
  children?: ReactNode;
}
export const RichTextEditorOverlay = (props: Props) => {
  if (!props.show) {
    return <>{props.children}</>;
  }
  return (
    <div className="c-rich-text__overlay">
      {props.children}
      <div className="c-rich-text__overlay__content">
        <img src={loadingImg} alt="" />
        目次を生成中です。
        <wbr />
        生成の目安は1〜2分です。
      </div>
    </div>
  );
};
